module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.objectId,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 left"
    }, [_c('comment-icon', {
      staticClass: "icon",
      attrs: {
        "event": comment.event
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-comment"
    }, [_c('comment-event', {
      attrs: {
        "event": comment.event
      }
    }), _vm._v(" (Usuário)")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 right"
    }, [_c('b', [_vm._v(_vm._s(_vm.format(comment.createdAt)))])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('b', [_vm._v("Eventos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af5d4a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/CommentTimelineOverview.vue
// module id = 1431
// module chunks = 1